import * as React from 'react'
import MultipleTextEditor from './multipleTextEditor.jsx'

interface PromptFieldProps {
  handleTextChange: any,
  text: string,
  incompletePrompt: Boolean,
  showBlockquote: Boolean,
  questionIndex: number,
  reset: any,
  blankInstructions?: any,
}

const PromptField = ({ handleTextChange, text, incompletePrompt, showBlockquote, questionIndex, blankInstructions, reset, }: PromptFieldProps) => {
  const labelId = `prompt-${questionIndex}-label`

  const labelElement = blankInstructions ? <div className="spread-label prompt-label" id={labelId}>Prompt {blankInstructions}</div> : <div className="prompt-label" id={labelId}>Prompt</div>

  return (
    <div className="prompt-field field">
      {/* not a <label>: the editor is a contenteditable, named via aria-labelledby */}
      {labelElement}
      <div className="control">
        <MultipleTextEditor
          handleTextChange={(e) => handleTextChange(e)}
          incompletePrompt={incompletePrompt}
          labelId={labelId}
          reset={reset}
          showBlockquote={showBlockquote}
          text={text}
        />
      </div>
    </div>
  )
}

export default PromptField
